import { Form } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import Radio from 'components/Form/RadioButton'
import TextArea from 'components/Form/TextArea'
import Select from 'components/Select'
import { RadioGroup } from 'components/UIComponents/FormStyles'
import { FooterFlex } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/InterviewerDrawer/style'
import {
  FormItem,
  StartSpan,
  TotalTimeDiv,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import React, { useEffect, useState } from 'react'
import Flex from '../../../../../components/Flex'

const AddRoundForm = ({
  setAddRoundDrawer,
  addRoundDrawer,
  isEditRoleOnView,
  setIsEdit,
  setInterviewer,
  setSortedItems,
  sortedItems,
  roundInfo,
  setRoundInfo,
  isEditRound,
  setIsEditRound,
}) => {
  const [form] = Form.useForm()
  const [name, setName] = useState('')
  const [type, setType] = useState('')
  const [description, setDescription] = useState('')
  const [validationErrors, setValidationErrors] = useState({})
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [assessmentType, setAssessmentType] = useState('')

  const RadioOptions = [
    {
      id: 1,
      label: 'Assessment',
      value: 'ASSESMENT',
      disabled: isEditRoleOnView,
    },
    {
      id: 2,
      label: 'Group Discussion',
      value: 'GROUP',
      disabled: isEditRoleOnView,
    },
    {
      id: 3,
      label: 'Face-to-face',
      value: 'FACE_TO_FACE',
      disabled: isEditRoleOnView,
    },
    {
      id: 4,
      label: 'External Assessment',
      value: 'EXTERNAL_ASSESMENT',
      disabled: isEditRoleOnView,
    },
  ]
  function removeHtmlTags(input) {
    const tempElement = document.createElement('div')
    tempElement.innerHTML = input
    return tempElement.textContent || tempElement.innerText || ''
  }
  useEffect(() => {
    if (isEditRound && roundInfo) {
      form.setFieldsValue({ name: roundInfo?.name })
      form.setFieldsValue({
        description: removeHtmlTags(roundInfo?.description),
      })
      form.setFieldsValue({ type: roundInfo?.type })
      form.setFieldsValue({ assessmentType: roundInfo?.assesmentType })
      setName(roundInfo?.name)
      setType(roundInfo?.type)
      setDescription(removeHtmlTags(roundInfo?.description))
      setAssessmentType(roundInfo?.assesmentType)
      setValidationErrors({})
    }
  }, [isEditRound])
  useEffect(() => {
    if (addRoundDrawer && !isFirstRender && !isEditRound) {
      form.resetFields()
      setName('')
      setType('')
      setDescription('')
      setValidationErrors({})
    } else {
      setIsFirstRender(false)
    }
  }, [addRoundDrawer, form, isFirstRender])

  const handleSubmit = async () => {
    try {
      await form.validateFields()
      const values = form.getFieldsValue()

      setSortedItems(prevItems => {
        const updatedItems = prevItems.map(item => {
          if (item === roundInfo) {
            return {
              ...item,
              ...values,
              order:
                roundInfo?.order ?? prevItems[prevItems?.length - 1]?.order + 1,
            }
          }
          return item
        })
        if (isEditRound) {
          return updatedItems
        } else {
          return [
            ...updatedItems,
            {
              ...values,
              order: prevItems[prevItems?.length - 1]?.order + 1,
            },
          ]
        }
      })

      setAddRoundDrawer(false)
      setIsEdit(true)
      setRoundInfo()
      setIsEditRound(false)
      setName('')
      setType('')
      setDescription('')
      setAssessmentType('')
    } catch (error) {
      const errors = error.errors
      setValidationErrors(errors)
    }
  }
  const onClose = () => {
    form.resetFields(['name', 'type', 'description', 'assesmentType'])
    setAddRoundDrawer(false)
    setInterviewer(true)

    if (isEditRound) {
      setIsEditRound(false)
    }
    setName('')
    setType('')
    setDescription('')
    setAssessmentType('')

    setValidationErrors(prevErrors => {
      const updatedErrors = { ...prevErrors }
      updatedErrors.name = undefined
      return updatedErrors
    })
  }
  const externalassesmentOptions = [
    {
      label: 'Test Gorilla',
      value: 'TEST_GORILA',
      disabled: false,
    },
    {
      label: 'eSkill',
      value: 'E_SKILL',
      disabled: false,
    },
  ]

  const content = () => {
    return (
      <div>
        <div>
          <Form form={form} layout="vertical">
            <FormItem
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please enter round name',
                  validateTrigger: 'onClick',
                },
              ]}
              validateStatus={validationErrors?.name ? 'error' : ''}
              help={validationErrors?.name}
            >
              <div>
                <TotalTimeDiv>
                  Round Name<StartSpan>*</StartSpan>
                </TotalTimeDiv>
                <Input
                  type="text"
                  width="100%"
                  placeholder="Add Round Name"
                  value={name}
                  onClick={() => {
                    setValidationErrors(prevErrors => ({
                      ...prevErrors,
                      name: undefined,
                    }))
                  }}
                  onChange={event => {
                    const inputValue = event.target.value
                    setName(inputValue)

                    const nameExists = sortedItems?.some(
                      item =>
                        item?.name?.replace(/\s/g, '')?.toUpperCase() ===
                        inputValue?.replace(/\s/g, '')?.toUpperCase()
                    )
                    if (nameExists) {
                      setValidationErrors(prevErrors => ({
                        ...prevErrors,
                        name: 'Round Name already exists',
                      }))
                    } else {
                      setValidationErrors(prevErrors => ({
                        ...prevErrors,
                        name: undefined,
                      }))
                    }
                  }}
                />
              </div>
            </FormItem>

            <TotalTimeDiv>
              Evaluation Type <StartSpan>*</StartSpan>
            </TotalTimeDiv>
            <FormItem
              name={'type'}
              rules={[
                {
                  required: true,
                  message: 'Please select  Evaluation Type',
                },
              ]}
            >
              <RadioGroup
                spaceBetween
                onChange={event => setType(event.target.value)}
                value={type}
              >
                {RadioOptions?.map((item, index) => (
                  <Radio
                    width={'50%'}
                    key={index + item?.value}
                    border={true}
                    label={item?.label}
                    value={item?.value}
                  />
                ))}
              </RadioGroup>
            </FormItem>
            {type == 'EXTERNAL_ASSESMENT' && (
              <>
                <Label>External Assessment Type *</Label>
                <FormItem
                  name="assesmentType"
                  rules={[
                    {
                      required: true,
                      message: 'Please select  Evaluation Type',
                    },
                  ]}
                >
                  <Select
                    value={assessmentType}
                    showArrow={false}
                    showSearch={true}
                    allowClear={true}
                    OptionData={externalassesmentOptions}
                    filterOption={true}
                    valueParam="value"
                    nameParam="label"
                    placeholder="Select External Assessment Type"
                    width="24%"
                  />
                </FormItem>
              </>
            )}
            <FormItem>
              <Flex spaceBetween>
                <TotalTimeDiv>
                  Round description<StartSpan>*</StartSpan>
                </TotalTimeDiv>
              </Flex>
              <TextArea
                placeholder={'e.g.  There is no negative marking.'}
                name="description"
                value={description}
                rules={[
                  {
                    required: true,
                    message: 'Please enter round description',
                  },
                ]}
                onChange={event => setDescription(event.target.value)}
              />
            </FormItem>
          </Form>
        </div>
      </div>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="88px"
          height="38px"
          text="Cancel"
          onClick={onClose}
        />
        <Button.Secondary
          width="69px"
          height="38px"
          text={isEditRound ? 'Edit' : 'Add'}
          htmlType="submit"
          disabled={validationErrors?.name}
          onClick={handleSubmit}
          style={{ background: 'rgb(50, 73, 215)', color: 'white' }}
        />
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="43%"
      title={isEditRound ? 'Edit Round' : 'Add Round'}
      placement="right"
      visible={addRoundDrawer}
      content={content()}
      footer={footer()}
      onClose={onClose}
      closable
    />
  )
}

export default AddRoundForm
